'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
import React from 'react';
import { findClosestGlyphAvailable, Icon, IconSizeMap } from "../../index.mjs";
export function IconRepeatOnce(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M0 4.75A3.75 3.75 0 0 1 3.75 1h.75v1.5h-.75A2.25 2.25 0 0 0 1.5 4.75v5A2.25 2.25 0 0 0 3.75 12H5v1.5H3.75A3.75 3.75 0 0 1 0 9.75v-5ZM12.25 2.5a2.25 2.25 0 0 1 2.25 2.25v5A2.25 2.25 0 0 1 12.25 12H9.81l1.018-1.018a.75.75 0 0 0-1.06-1.06L6.939 12.75l2.829 2.828a.75.75 0 1 0 1.06-1.06L9.811 13.5h2.439A3.75 3.75 0 0 0 16 9.75v-5A3.75 3.75 0 0 0 12.25 1h-.75v1.5h.75Z\'/><path d=\'m8 1.85.77.694H6.095V1.488c.697-.051 1.2-.18 1.507-.385.316-.205.51-.51.583-.913h1.32V8H8V1.85Z\'/><path d=\'M8.77 2.544 8 1.85v.693h.77Z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M1 7a5 5 0 0 1 5-5h1v2H6a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h1v2H6a5 5 0 0 1-5-5V7Zm17-3h-1V2h1a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5h-7.202v-2H18a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3Z\'/><path d=\'M14.5 15.288a1 1 0 0 1 0 1.414L12.202 19l2.298 2.298a1 1 0 0 1-1.414 1.415L9.373 19l3.713-3.712a1 1 0 0 1 1.414 0ZM11.967 3.202l1.008.91H9.559v-1.4c.877-.065 1.517-.229 1.918-.49s.649-.649.742-1.162h1.75V11h-2.002V3.202Z\'/><path d=\'m12.975 4.112-1.008-.91v.91h1.008Z\'/>'
  }];
  var iconSizeValue = props.size ? IconSizeMap[props.size] : props.iconSize;
  var closestSize = findClosestGlyphAvailable(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconRepeatOnce is deprecated and will be archived soon. Use IconRepeatOnce instead.
 */
export function Experimental__IconRepeatOnce(props) {
  return /*#__PURE__*/React.createElement(IconRepeatOnce, props);
}